import {fetchAllListPages} from '../../../service/listPagination'
import { piiActions } from "../../../service/permissions";
import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

import { useIntl } from "react-intl";
import { TextField } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete';
import {  baseURL } from "../../../service/API.js"
import { useSelector } from "react-redux";

export const CreateRole = () => {
    const intl = useIntl();
    const suhbeader = useSubheader();
    suhbeader.setTitle(intl.formatMessage({ id: "113180", defaultMessage: "Menu" }));
    const history = useHistory();
    const [data, setData] = useState([]);
    const [_test, setTest] = useState([])
    const [_order_item, _setOrder_item] = useState(1)
    const [_titleEN, _setTitleEN] = useState('');
    const [role, setRole] = useState('');
    const [_descriptionEN, _setDescriptionEN] = useState('');
    const [_descriptionTH, _setDescriptionTH] = useState('');
    const [listPage, setListPage] = useState([]);
    const [_groupDeal, _setGroupDeal] = useState([]);
    const [_listDeal, _setListDeal] = useState([]);
    const [_bannerList, _setbannerList] = useState([]);
    const { _user, _authToken, _accessTokenPrivilege } = useSelector((state) => state.auth);
    const [_listGroup2, _setListGroup2] = useState([]);
    const [typeList, _setTypeList] = useState([
        'VIEW', 'CREATE', 'EDIT', 'DELETE', 'IMPORT', 'EXPORT', 'ADMIN'
    ]);
    const [_projectList, _setProjectList] = useState([])
    const [_isUpload, _setIsUpload] = useState(false);
    const [_progress, _setProgress] = useState(0);

    const [_fixedlist, _setfixedList] = useState([])
    const [_brandList, _setBrandtList] = useState([])
    const [_is_active, _setIs_active] = useState(true);
    const [_for_you, _setFor_you] = useState(false);
    const [_summary, _setSummary] = useState([]);
    const [_targetlist, _setTargetlist] = useState([]);


    const [_whiteList, _setWhiteList] = useState([])
    const setMapData = (data) => {
        let temp = []
        data.map(item => {
            temp.push({
                key: item.key,
                condition: item.condition,
                value: item.value,
                value_string: item.value_string,
                options: item.options,
                id: item.id,
                showDate: item.showDate,
                showOneDate: item.showOneDate,
                showListValue: item.showListValue,
                showOption: item.showOption,
                showValue: item.showValue,
                groupName: item.groupName,
                listValue: item.listValue,

                selectOption: item.selectOption,
                one_date: item.one_date,
                start_date: item.start_date,
                end_date: item.end_date
            })

                  return null;
})
        setData(temp)
        setTest(temp)
    }

    const getListPage = async () => {
        let token = localStorage.getItem("Token")
        fetchAllListPages(`${baseURL}/api/v1/role/page?time=1&page=1&limit=100`, {
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
        }).then((res) => {
            if (res.message) {
            } else {
                setListPage(res.data.data)
            }
        }).catch((err) => {
        });
    };

    const updateFieldChanged = (index, value, name) => {
        let newArr = [...data]; // copying the old datas array
        newArr[index][name] = value; // replace e.target.value with whatever you want to change it to
        setData(newArr)
        
    }
    useEffect(() => {
        getListPage()

        setMapData([{
            page: '',
            page_id: '',
            
            permission: []
        }])
    }, []);

    const AlertError = (message) => {
        Swal.fire("Menu Management!", message, "error");
    };

    const onSubmit = async () => {
        if (role === undefined || role === "") {
            return AlertError("Please insert Role");
        }
        console.log('data', data);
        // return false;

        let temp = []
        for (let i in data) {
            if (data[i].page === undefined || data[i].page === '') {
                return AlertError(`Please insert page at permission number ${Number(i) + 1}`);
            }
            if (data[i].permission === [] || data[i].permission.length === 0) {
                return AlertError(`Please insert type at permission number ${Number(i) + 1}`);
            }
            data[i].permission.map((item)=>{
                temp.push({
                    page: data[i].page,
                    page_id: data[i].page_id,
                    type: item,
                })
                          return null;
})
            console.log(temp)
        }
        var events = {
            role: role,
            permission: temp
        };
        let apiUrls = `${baseURL}/api/v1/role`;
        let token = localStorage.getItem("Token");
        Swal.fire({
            title: "",
            text: 'Confirm Create',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            showLoaderOnConfirm: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                axios({
                    method: "post",
                    url: apiUrls,
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    data: events,
                })
                    .then(async (res) => {
                        history.goBack();
                    })
                    .catch((err) => {
                        Swal.fire(
                            "Create !",
                            "Your can not create. !! " + err,
                            "error"
                        );
                    });
            }
        })


        return false;
    };

    const addPermission = () => {
        let temp = {
            page: '',
            page_id: '',
            
            permission: []
        }
        setData(data => [...data, temp])
    }

    const DeleteQuestion = (index) => {
        var array = [...data]; // make a separate copy of the array
        array.splice(index, 1);
        setData(array);
    }

    return (
        <>
            <Card>
                <CardHeader title={intl.formatMessage({ id: "113180", defaultMessage: "Create Target Group" })}>
                    <CardHeaderToolbar>
                        {/*<Link to="/TargetlistTopic">
                            <button type="button" clas  sName="btn btn-primary">
                                Manage Target list
                            </button>
                        </Link>*/}
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>

                    <div className="form-inline" style={{ marginBottom: "25px" }}>
                        <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
                            <span style={{ color: "red" }}>

                            </span>
                            {intl.formatMessage({ id: "113178", defaultMessage: "Target Group Name" })}<span style={{ color: "red" }}>
                                *
                            </span>:{" "}
                        </p>
                        <input
                            name="modelGroup"
                            style={{
                                height: "38px",
                                width: "530px",
                                backgroundColor: "#F4F6F9",
                                borderRadius: "5px",
                                borderWidth: "0",
                            }}
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                        />

                    </div>

                    

                    {data.length === 0 ?
                        <button type="button" className="btn btn-primary mr-2" onClick={() => {
                            addPermission()
                        }}>
                            {intl.formatMessage({ id: "099027", defaultMessage: "ADD" })}
                        </button>
                        : null}


                    {data.map((item, index) => (
                        <Card className="Small shadow" key={index}>
                            <CardHeader title={index + 1}>
                            </CardHeader>
                            <CardBody>
                                <div className="form-inline" style={{ marginBottom: "25px" }}>
                                    <p style={{ marginTop: "15px", float: "left", width: "20%" }}>

                                        {intl.formatMessage({ id: "113179", defaultMessage: "Page" })}<span style={{ color: "red" }}>
                                            *
                                        </span>:{" "}
                                    </p>
                                    <Autocomplete
                                        id="grouped-demo"
                                        options={listPage}
                                        getOptionLabel={(option) => option.page_name}
                                        //getOptionSelected={(option, value) => option.key == value.key}
                                        value={listPage.find(page => page.id === item.page_id) || null}
                                        onChange={(event, newValue) => {
                                            console.log(newValue)
                                            setData(previous => previous.map((entry, rowIndex) => rowIndex !== index ? entry : {
                                                ...entry, page: newValue ? newValue.page_name : '', page_id: newValue ? newValue.id : '',
                                                permission: (entry.permission || []).filter(action => newValue && piiActions(newValue.page_name, typeList).includes(action)),
                                            }))

                                        }}
                                        style={{
                                            width: "530px",
                                            backgroundColor: "#F4F6F9",
                                            borderRadius: "5px",
                                            borderWidth: "0",
                                        }}
                                        renderInput={(params) =>
                                            <TextField {...params} variant="outlined" />
                                        }
                                    />
                                </div>

                                <div className="form-inline" style={{ marginBottom: "25px" }}>
                                    <p style={{ marginTop: "15px", float: "left", width: "20%" }}>

                                        {intl.formatMessage({ id: "113181", defaultMessage: "Permission type" })}<span style={{ color: "red" }}>
                                            *
                                        </span>:{" "}
                                    </p>
                                    <Autocomplete
                                        id="grouped-demo"
                                        options={piiActions(item.page, typeList)}
                                        multiple
                                        //getOptionLabel={(option) => option.label}
                                        //getOptionSelected={(option, value) => option.key == value.key}
                                        value={item.permission || []}
                                        onChange={(event, newValue) => {
                                            console.log(newValue)
                                            updateFieldChanged(index, newValue, 'permission')
                                        }}
                                        style={{
                                            width: "530px",
                                            backgroundColor: "#F4F6F9",
                                            borderRadius: "5px",
                                            borderWidth: "0",
                                        }}
                                        renderInput={(params) =>
                                            <TextField {...params} variant="outlined" />
                                        }
                                    />
                                </div>

                                <CardFooter>
                                    <CardHeaderToolbar>

                                        <button type="button" className="btn btn-danger mr-2" onClick={() => { DeleteQuestion(index) }}>
                                            {intl.formatMessage({ id: "099027", defaultMessage: "DELETE" })}
                                        </button>

                                        {index === data.length - 1 ?
                                            <button type="button" className="btn btn-primary mr-2" onClick={() => {
                                                addPermission()
                                            }}>
                                                {intl.formatMessage({ id: "099027", defaultMessage: "ADD" })}
                                            </button>
                                            : null}
                                    </CardHeaderToolbar>
                                </CardFooter>
                            </CardBody>
                        </Card>
                    ))}

                    <div
                        className="form-inline"
                        style={{
                            marginBottom: "25px",
                        }}
                    >
                        <div
                            style={{
                                marginTop: "15px",
                                float: "left",
                                width: "20%",
                            }}
                        ></div>
                        <Link to="/Role">
                            <button type="button" className="btn btn-secondary wbt mr-5">
                                {intl.formatMessage({ id: "099065", defaultMessage: "Cancel" })}
                            </button>
                        </Link>
                        <button className="btn btn-primary" onClick={() => onSubmit()}>
                            {intl.formatMessage({ id: "099064", defaultMessage: "Save" })}
                        </button>
                    </div>

                </CardBody>
            </Card>
        </>
    );
};
